import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { useRealtimeStore } from '@/features/realtime/model'
import { useSearchStore } from '@/features/search/model'
import { useAuthStore } from '../model/auth.store'

/**
 * Hook to handle the complete logout process.
 * Calls the Zustand store's logout action for core auth state management
 * and performs necessary cleanup actions like query cache reset and router invalidation.
 */
export function useLogout() {
  const router = useRouter()
  const queryClient = useQueryClient()
  const authStore = useAuthStore()
  const realtimeStore = useRealtimeStore()
  const searchStore = useSearchStore()

  return async () => {
    authStore.setLoading(true)

    authStore.logout()
    realtimeStore.reset()
    searchStore.reset()

    // Invalidate router state to force re-evaluation of routes/loaders
    await router.invalidate()

    queryClient.resetQueries()

    router.navigate({ to: '/', replace: true })

    authStore.setLoading(false)
  }
}
